/* VANDAL CUSTOM STUDIO — silnik konfiguratora
   Tryb: chain (zawieszki na lancuchu). Kolejne tryby dokladane jako moduly. */
(function () {
  "use strict";

  var CFG = window.VANDAL_CFG;
  if (!CFG) return;

  var root = document.getElementById("vandal-builder");
  if (!root) return;

  var $ = function (s) { return root.querySelector(s); };
  var canvas = $(".vb-canvas"), chainEl = $(".vb-chain"), zoneEl = $(".vb-zone"), midEl = $(".vb-mid");
  var CHAIN_Y = 0.34;

  /* Jeden produkt, kilka lancuszkow. Kazdy niesie wlasna grubosc w mm, z ktorej
     wynika cala skala, wiec przelaczenie lancuszka przelicza scene od nowa.
     Gdy sekcja nie poda listy (starsza wersja pliku), budujemy ja z pojedynczych
     ustawien — dzieki temu silnik dziala takze przed wgraniem nowej sekcji. */
  if (!CFG.chains || !CFG.chains.length) {
    CFG.chains = [{
      key: CFG.chainKey || "gruby",
      label: (CFG.chainName || "").trim() || "Łańcuch",
      tile: CFG.chainTile,
      widthMm: CFG.chainWidthMm,
      gapLinks: CFG.gapLinks
    }];
  }
  function chain() { return CFG.chains[state.chainIx] || CFG.chains[0]; }

  function clampCm(v) { return Math.max(CFG.lenMin, Math.min(CFG.lenMax, Math.round(v))); }

  var state = {
    sizeMm: CFG.sizes[Math.floor((CFG.sizes.length - 1) / 2)],
    cm: clampCm(CFG.lenDefault),
    els: [], seq: 0, sel: null, chainIx: 0,
    claspId: (CFG.clasps[0] || {}).id || null,
    adjuster: !!CFG.adjusterDefault,
    designId: null, saving: false, dirty: false
  };

  /* Dotyk i mysz dostaja rozne modele usuwania, wiec silnik musi wiedziec,
     czym klient obsluguje konfigurator. */
  var COARSE = false;
  try { COARSE = window.matchMedia("(hover: none)").matches; } catch (e) {}

  /* ---------- geometria ---------- */
  var geo = { x0: 0, x1: 0, l0: 0, l1: 0, pxPerMm: 1 };

  function linkMm() { return chain().widthMm / CFG.tileAspect / CFG.linksPerTile; }
  function linkCount() { return Math.round(state.cm * 10 / linkMm()); }
  function perLinkPx() { return (geo.x1 - geo.x0) / Math.max(1, geo.l1 - geo.l0); }
  function totalCm() { return state.cm + (state.adjuster ? CFG.adjExtraCm : 0); }

  /* Uklad sceny: [odstep][ZAPIECIE][===== lancuch =====][REGULATOR][odstep]
     Szerokosc osprzetu zalezy od skali, a skala od tego ile miejsca zostalo
     na lancuch — wiec liczymy to w kilku przebiegach, az sie ustali.
     Gdy regulator jest wylaczony, lancuch przejmuje jego miejsce. */
  function measure() {
    var W = canvas.clientWidth, pad = W * 0.02;
    var cw = W * CFG.claspSlot, aw = state.adjuster ? W * CFG.adjSlot : 0, px = 1;

    for (var i = 0; i < 4; i++) {
      var chainW = Math.max(40, W - 2 * pad - cw - aw);
      px = chainW / (state.cm * 10);
      cw = Math.min(W * 0.20, CFG.claspMm * px * CFG.hwScale);
      aw = state.adjuster ? Math.min(W * 0.34, CFG.adjusterMm * px * CFG.hwScale) : 0;
    }

    geo.claspW = cw; geo.adjW = aw; geo.pad = pad;
    geo.cx0 = pad + cw;
    geo.cx1 = W - pad - aw;
    var chainW2 = Math.max(40, geo.cx1 - geo.cx0);
    geo.pxPerMm = chainW2 / (state.cm * 10);
    /* Strefa robocza: stale CFG.edgeCm centymetrow zapasu z obu koncow.
       To kawalek lancucha, ktory lezy gleboko na karku — zawieszka tam
       zawieszona i tak byłaby niewidoczna. Liczone w realnych cm, wiec
       przy dluzszym lancuchu zostaje tyle samo zapasu, nie procent. */
    var n = linkCount();
    var edge = Math.round(CFG.edgeCm * 10 / linkMm());
    edge = Math.max(0, Math.min(edge, Math.floor((n - 8) / 2)));   /* zawsze zostaw kawalek na projekt */
    geo.l0 = edge; geo.l1 = n - edge;
    geo.x0 = geo.cx0 + chainW2 * (geo.l0 / n);
    geo.x1 = geo.cx0 + chainW2 * (geo.l1 / n);
    zoneEl.style.left = geo.x0 + "px"; zoneEl.style.width = (geo.x1 - geo.x0) + "px";
    if (midEl) midEl.style.left = midX() + "px";
  }
  function linkToX(l) { return geo.x0 + (l - geo.l0) / Math.max(1, geo.l1 - geo.l0) * (geo.x1 - geo.x0); }
  function xToLinkF(x) { return geo.l0 + (x - geo.x0) / Math.max(1, geo.x1 - geo.x0) * (geo.l1 - geo.l0); }
  function xToLink(x) { return Math.round(xToLinkF(x)); }
  /* Os symetrii: polowa lancucha miedzy zapieciem a koncem. Regulator jej nie
     przesuwa — zalozony lancuch klient i tak poprawia rekoma, a przy projekcie
     potrzebuje jednego, stalego punktu odniesienia. */
  function midX() { return (geo.cx0 + geo.cx1) / 2; }

  /* Pliki glifow sa przyciete dokladnie do metalu, wiec sizeMm to wprost
     wysokosc obrazka, a ax/ay wskazuja otwor montazowy w jego obrebie. */
  function dims(code) {
    var g = CFG.glyphs[code], h = state.sizeMm * geo.pxPerMm;
    return { w: h * g.w / g.h, h: h, ax: g.ax, ay: g.ay };
  }
  function extent(el) {
    var d = dims(el.code), x = linkToX(el.link);
    return [x - d.ax * d.w, x + (1 - d.ax) * d.w];
  }
  function clashing(el) {
    var a = extent(el);
    return state.els.some(function (o) {
      if (o.uid === el.uid) return false;
      var b = extent(o); return a[0] < b[1] && b[0] < a[1];
    });
  }

  /* ---------- cena ---------- */
  function tier() {
    var n = state.els.length;
    for (var i = 0; i < CFG.tiers.length; i++)
      if (n >= CFG.tiers[i].min && n <= CFG.tiers[i].max) return CFG.tiers[i];
    return CFG.tiers[0];
  }
  function money(gr) {
    return (gr / 100).toFixed(2).replace(".", ",") + " zł";
  }

  /* ---------- rysowanie ---------- */
  function drawChain() {
    var tileW = perLinkPx() * CFG.linksPerTile;
    var tileH = tileW * CFG.tileAspect, y = canvas.clientHeight * CHAIN_Y;
    chainEl.style.backgroundImage = "url(" + chain().tile + ")";
    chainEl.style.backgroundSize = tileW + "px " + tileH + "px";
    chainEl.style.height = tileH + "px";
    chainEl.style.top = (y - tileH / 2) + "px";
    chainEl.style.left = geo.cx0 + "px";
    chainEl.style.right = "auto";
    chainEl.style.width = (geo.cx1 - geo.cx0) + "px";
    chainEl.style.backgroundPositionX = "0px";
  }

  /* Osprzet rysujemy w tej samej skali co zawieszki — klient widzi prawdziwe
     proporcje. Szczegol zapiecia oglada w kafelkach wyboru, nie na lancuchu. */
  var hwNodes = {};
  function hardware() {
    var y = canvas.clientHeight * CHAIN_Y;

    var clasp = CFG.clasps.filter(function (c) { return c.id === state.claspId; })[0];
    var cn = hwNodes.clasp;
    if (clasp) {
      if (!cn) {
        cn = document.createElement("div");
        cn.className = "vb-hw";
        cn.innerHTML = '<img alt=""><span class="vb-hw-tag"></span>';
        canvas.appendChild(cn); hwNodes.clasp = cn;
      }
      var cw = geo.claspW, ch = cw / clasp.ratio;
      cn.querySelector("img").src = clasp.url;
      cn.querySelector(".vb-hw-tag").textContent = clasp.label;
      cn.style.width = cw + "px";
      cn.style.left = geo.pad + "px";                      /* rowno z lewa krawedzia */
      cn.style.top = (y - ch / 2) + "px";
      cn.setAttribute("data-on", "1");
    } else if (cn) { cn.setAttribute("data-on", "0"); }

    var an = hwNodes.adj;
    if (CFG.adjuster && CFG.adjuster.url) {
      if (!an) {
        an = document.createElement("div");
        an.className = "vb-hw";
        an.innerHTML = '<img alt=""><span class="vb-hw-tag"></span>';
        canvas.appendChild(an); hwNodes.adj = an;
      }
      var aw = geo.adjW || (CFG.adjusterMm * geo.pxPerMm * CFG.hwScale);
      var ah = aw / CFG.adjuster.ratio;
      an.querySelector("img").src = CFG.adjuster.url;
      an.querySelector(".vb-hw-tag").textContent = "regulator +" + CFG.adjExtraCm + " cm";
      an.style.width = aw + "px";
      an.style.left = geo.cx1 + "px";                      /* zaraz za lancuchem */
      an.style.top = (y - ah / 2) + "px";
      an.setAttribute("data-on", state.adjuster ? "1" : "0");
    }
  }

  var nodes = {};

  function spread() {
    var n = state.els.length; if (!n) return;
    var ws = state.els.map(function (e) { return dims(e.code).w; });
    var total = ws.reduce(function (a, b) { return a + b; }, 0);
    var gap = Math.max(2, perLinkPx() * chain().gapLinks);
    var cur = (geo.x0 + geo.x1) / 2 - (total + gap * (n - 1)) / 2;
    state.els.forEach(function (e, i) {
      if (e.link) return;
      e.link = xToLink(cur + dims(e.code).ax * ws[i]);
      cur += ws[i] + gap;
    });
  }

  function place(node, el) {
    var d = dims(el.code), y = canvas.clientHeight * CHAIN_Y;
    node.style.width = d.w + "px";
    node.style.transform = "translate3d(" + (linkToX(el.link) - d.ax * d.w) + "px," + (y - d.ay * d.h) + "px,0)";
    node.classList.toggle("vb-clash", clashing(el));
  }

  function render() {
    measure(); drawChain(); hardware(); spread();
    var seen = {};
    state.els.forEach(function (el) {
      seen[el.uid] = 1;
      var node = nodes[el.uid];
      if (!node) {
        node = document.createElement("div");
        node.className = "vb-pendant";
        node.tabIndex = 0;
        node.setAttribute("role", "slider");
        node.setAttribute("aria-label", "Zawieszka " + el.code + ", strzalkami przesun wzdluz lancucha");
        node.setAttribute("data-uid", el.uid);
        node.innerHTML = '<img src="' + CFG.glyphs[el.code].url + '" alt="' + el.code + '" draggable="false">' +
                         '<button type="button" class="vb-kill" aria-label="Usun ' + el.code + '">&times;</button>';
        node.querySelector(".vb-kill").addEventListener("click", function (ev) {
          ev.stopPropagation(); remove(el.uid);
        });
        bindKeys(node, el);
        canvas.appendChild(node); nodes[el.uid] = node;
      }
      place(node, el);
    });
    Object.keys(nodes).forEach(function (uid) {
      if (!seen[uid]) { nodes[uid].remove(); delete nodes[uid]; }
    });
    paint(); paintSel();
  }

  function slotFor(code) {
    var d = dims(code), gap = Math.max(3, perLinkPx() * chain().gapLinks), need = d.w + gap;
    var occ = state.els.map(extent).sort(function (a, b) { return a[0] - b[0]; });
    var gaps = [], cur = geo.x0;
    occ.forEach(function (o) { if (o[0] - cur > 0) gaps.push([cur, o[0]]); cur = Math.max(cur, o[1]); });
    if (geo.x1 - cur > 0) gaps.push([cur, geo.x1]);
    var fit = gaps.filter(function (g) { return g[1] - g[0] >= need; });
    var pick = fit.length ? fit[fit.length - 1]
             : gaps.length ? gaps.reduce(function (a, b) { return (b[1] - b[0]) > (a[1] - a[0]) ? b : a; })
             : [(geo.x0 + geo.x1) / 2 - need / 2, 0];
    return xToLink(pick[0] + gap / 2 + d.ax * d.w);
  }

  function add(code) {
    if (state.els.length >= CFG.maxElements) return;
    state.els.push({ uid: ++state.seq, code: code, link: slotFor(code) });
    lenBase = null;
    state.dirty = true; render(); paintRail(); queueSave();
  }
  /* Usuniecie jest natychmiastowe, ale przez chwile odwracalne — na telefonie
     zawieszka ma ~20 px szerokosci i pomylka jest kwestia milimetra palca.
     Ten sam mechanizm obsluguje jedna zawieszke i kasowanie calego projektu,
     wiec klient uczy sie jednego zachowania zamiast dwoch. */
  var lastKill = null, undoTimer = 0;

  function szt(n) {
    var d = n % 10, s = n % 100;
    return n + " " + (n === 1 ? "zawieszka"
      : (d >= 2 && d <= 4 && (s < 10 || s > 20)) ? "zawieszki" : "zawieszek");
  }

  function kill(list, label) {
    if (!list.length) return;
    var items = list.map(function (el) {
      return { at: state.els.indexOf(el), uid: el.uid, code: el.code, link: el.link };
    }).sort(function (a, b) { return a.at - b.at; });
    /* od konca, zeby wczesniejsze indeksy zostaly wazne */
    for (var i = items.length - 1; i >= 0; i--) state.els.splice(items[i].at, 1);
    if (items.some(function (it) { return it.uid === state.sel; })) state.sel = null;
    lastKill = items;
    lenBase = null;
    state.dirty = true; render(); paintRail(); queueSave();
    showUndo(label);
  }
  function remove(uid) {
    var el = null;
    state.els.forEach(function (e) { if (e.uid === uid) el = e; });
    if (el) kill([el], el.code);
  }
  function resetAll() {
    kill(state.els.slice(), szt(state.els.length));
  }
  function undoKill() {
    if (!lastKill || !lastKill.length) { hideUndo(); return; }
    var items = lastKill;
    hideUndo();
    for (var i = 0; i < items.length; i++) {
      if (state.els.length >= CFG.maxElements) break;
      state.els.splice(Math.min(items[i].at, state.els.length), 0,
                       { uid: items[i].uid, code: items[i].code, link: items[i].link });
    }
    state.sel = items.length === 1 ? items[0].uid : null;
    lenBase = null;
    state.dirty = true; render(); paintRail(); queueSave();
  }

  /* Wyrownanie napisu wzgledem osi symetrii. Przesuwamy caly uklad o te sama
     liczbe ogniw, zeby nie psuc odstepow, ktore klient sam ustawil. Liczymy od
     obrysu metalu, nie od otworow montazowych — symetryczny ma byc napis. */
  function centerAll() {
    if (!state.els.length) return;
    var lo = 1e9, hi = -1e9, minL = 1e9, maxL = -1e9;
    state.els.forEach(function (e) {
      var x = extent(e);
      if (x[0] < lo) lo = x[0];
      if (x[1] > hi) hi = x[1];
      if (e.link < minL) minL = e.link;
      if (e.link > maxL) maxL = e.link;
    });
    var d = Math.round((midX() - (lo + hi) / 2) / perLinkPx());
    d = Math.max(geo.l0 - minL, Math.min(geo.l1 - maxL, d));
    if (!d) return;
    state.els.forEach(function (e) { e.link += d; });
    lenBase = null;
    state.dirty = true; render(); queueSave();
  }

  /* Rowne odstepy miedzy zawieszkami. Liczymy je w OGNIWACH, nie w pikselach:
     klient i warsztat patrza na kolumne "ogniw od poprzedniej" na karcie
     produkcyjnej i jedna zawieszka 7 ogniw od poprzedniej obok drugiej z 10
     wyglada jak pomylka, nawet gdy na oko jest rowno. Litery maja rozna
     szerokosc, wiec przy jednym skoku otworow montazowych swiatlo miedzy
     metalem bywa rozne — za to skok jest wszedzie ten sam.
     Skok bierzemy z obecnego ukladu i podnosimy tylko tyle, zeby zadna para
     sasiadow sie nie zetknela. Srodek ukladu zostaje tam, gdzie byl. */
  function evenGaps() {
    var n = state.els.length;
    if (n < 3) return;
    var sorted = state.els.slice().sort(function (a, b) { return a.link - b.link; });
    var per = perLinkPx(), minGap = Math.max(2, per * chain().gapLinks);

    var pMin = 1;
    for (var i = 0; i < n - 1; i++) {
      var a = dims(sorted[i].code), b = dims(sorted[i + 1].code);
      pMin = Math.max(pMin, Math.ceil(((1 - a.ax) * a.w + b.ax * b.w + minGap) / per));
    }

    var first = sorted[0].link, last = sorted[n - 1].link;
    var p = Math.max(pMin, Math.round((last - first) / (n - 1)));

    var room = geo.l1 - geo.l0;
    if (p * (n - 1) > room) p = Math.max(1, Math.floor(room / (n - 1)));
    var total = p * (n - 1);

    var f = Math.round((first + last) / 2 - total / 2);
    f = Math.max(geo.l0, Math.min(geo.l1 - total, f));

    sorted.forEach(function (e, i) { e.link = f + i * p; });
    lenBase = null;
    state.dirty = true; render(); queueSave();
  }

  /* ---------- zaznaczenie ----------
     Na dotyku krzyzyka nie ma w ogole: tapniecie zaznacza zawieszke, a usuwa
     przycisk w pasku pod scena — kilkadziesiat pikseli od lancucha, wiec palec
     szukajacy zawieszki nie ma jak w niego trafic. */
  var selBar = $(".vb-selbar"), selTxt = $(".vb-sel-txt"), selDel = $(".vb-sel-del");
  var centerBtn = $(".vb-sel-mid"), evenBtn = $(".vb-sel-even"), resetBtn = $(".vb-reset");
  var undoBox = $(".vb-undo"), undoTxt = $(".vb-undo-txt"), undoBtn = $(".vb-undo-btn");
  var HINT = (COARSE ? "Tapnij" : "Kliknij") + " zawieszkę, aby zaznaczyć";

  function paintSel() {
    var el = null;
    state.els.forEach(function (e) { if (e.uid === state.sel) el = e; });
    if (!el) state.sel = null;
    Object.keys(nodes).forEach(function (uid) {
      nodes[uid].classList.toggle("vb-sel", !!el && +uid === el.uid);
    });
    /* wyrownanie i kasowanie projektu maja sens dopiero, gdy cos na lancuchu wisi */
    var any = state.els.length > 0;
    if (centerBtn) centerBtn.hidden = !any;
    if (resetBtn) resetBtn.hidden = !any;
    /* przy jednej i dwoch zawieszkach nie ma czego wyrownywac — jest zero
       albo jeden odstep, wiec przycisk bylby martwy */
    if (evenBtn) evenBtn.hidden = state.els.length < 3;
    if (!selBar) return;
    if (el) {
      selTxt.textContent = "Zaznaczono ";
      var b = document.createElement("b");
      b.textContent = el.code;
      selTxt.appendChild(b);
      selDel.setAttribute("aria-label", "Usuń zawieszkę " + el.code);
    } else {
      selTxt.textContent = state.els.length ? HINT : "";
    }
    selDel.hidden = !el;
  }
  function setSel(uid) {
    if (state.sel === uid) return;
    state.sel = uid; paintSel();
  }

  function showUndo(label) {
    if (!undoBox) return;
    undoTxt.textContent = "Usunięto " + label;
    undoBox.hidden = false;
    clearTimeout(undoTimer);
    undoTimer = setTimeout(hideUndo, 6000);
  }
  function hideUndo() {
    clearTimeout(undoTimer);
    if (undoBox) undoBox.hidden = true;
    lastKill = null;
  }

  /* ---------- lupa ----------
     Palec zakrywa zawieszke, wiec podczas przeciagania ten sam fragment sceny
     pokazujemy powiekszony nad lancuchem. Podglad w realnej skali zostaje
     nietkniety — lupa jest tylko na czas ruchu. */
  var loupe = $(".vb-loupe"), loupeIn = $(".vb-loupe-in");
  var LZ = 2.6, LW = 150, LH = 78, loupeNode = null;

  function loupeOpen(el) {
    if (!COARSE || !loupe || !loupeIn) return;
    try {
      loupeIn.innerHTML = "";
      loupeIn.innerHTML = canvas.innerHTML;
      var s1 = loupeIn.querySelector(".vb-loupe"); if (s1) s1.parentNode.removeChild(s1);
      var s2 = loupeIn.querySelector(".vb-undo");  if (s2) s2.parentNode.removeChild(s2);
      var s3 = loupeIn.querySelector(".vb-reset"); if (s3) s3.parentNode.removeChild(s3);
      loupeIn.style.width = canvas.clientWidth + "px";
      loupeIn.style.height = canvas.clientHeight + "px";
      loupeNode = loupeIn.querySelector('[data-uid="' + el.uid + '"]');
      if (loupeNode) loupeNode.classList.remove("vb-dragging");
      loupe.hidden = false;
      loupeMove(el, nodes[el.uid].style.transform);
    } catch (e) { loupeClose(); }
  }
  function loupeMove(el, tf) {
    if (!loupe || loupe.hidden) return;
    if (loupeNode && tf) loupeNode.style.transform = tf;
    var d = dims(el.code), y = canvas.clientHeight * CHAIN_Y;
    var cx = linkToX(drag.el ? drag.live : el.link), cy = y + d.h * 0.35;
    /* transform-origin 0 0, wiec punkt p sceny lezy w Z*(p+t) — stad t */
    loupeIn.style.transform = "scale(" + LZ + ") translate(" +
      (LW / (2 * LZ) - cx).toFixed(2) + "px," + (LH / (2 * LZ) - cy).toFixed(2) + "px)";
    loupe.style.left = Math.max(4, Math.min(canvas.clientWidth - LW - 4, cx - LW / 2)) + "px";
    loupe.style.top = Math.max(4, y - LH - 16) + "px";
  }
  function loupeClose() {
    if (!loupe) return;
    loupe.hidden = true; loupeIn.innerHTML = ""; loupeNode = null;
  }

  /* ---------- przeciaganie ----------
     Jeden uchwyt na calej scenie zamiast osobnego na kazdej zawieszce.
     Przy szerokosci sceny 388 px zawieszki stoja 23 px od siebie, a palec
     potrzebuje 44 px — powiekszone pola dotyku musza wiec zachodzic na siebie.
     Dlatego nie pytamy przegladarki, w co trafil palec, tylko sami bierzemy te
     zawieszke, ktorej srodek jest najblizej punktu dotkniecia. */
  var HALF_X = 22, HALF_Y = 26, SNAP_PX = 7;
  var drag = { el: null, node: null, id: -1, sx: 0, sl: 0, live: 0, raf: 0, moved: false };

  function hit(ev) {
    var r = canvas.getBoundingClientRect();
    var x = ev.clientX - r.left, y = ev.clientY - r.top;
    var best = null, bd = 1e9;
    state.els.forEach(function (el) {
      var node = nodes[el.uid]; if (!node) return;
      var b = node.getBoundingClientRect();
      var cx = b.left + b.width / 2 - r.left, cy = b.top + b.height / 2 - r.top;
      var hx = Math.max(b.width / 2, COARSE ? HALF_X : 0);
      var hy = Math.max(b.height / 2, COARSE ? HALF_Y : 0);
      var dx = Math.abs(x - cx);
      if (dx > hx || Math.abs(y - cy) > hy) return;
      if (dx < bd) { bd = dx; best = el; }
    });
    return best;
  }

  function onDown(ev) {
    var cl = ev.target && ev.target.classList;
    if (cl && (cl.contains("vb-kill") || cl.contains("vb-reset"))) return;
    var el = hit(ev);
    if (!el) { setSel(null); return; }
    drag.el = el; drag.node = nodes[el.uid]; drag.id = ev.pointerId;
    drag.sx = ev.clientX; drag.sl = el.link; drag.live = el.link; drag.moved = false;
    try { canvas.setPointerCapture(ev.pointerId); } catch (e) {}
    drag.node.classList.add("vb-dragging");
    drag.node.classList.remove("vb-settling");
    setSel(el.uid);
    try { drag.node.focus({ preventScroll: true }); } catch (e) {}
    ev.preventDefault();
  }

  function onMove(ev) {
    if (!drag.el || ev.pointerId !== drag.id) return;
    if (!drag.moved) {
      if (Math.abs(ev.clientX - drag.sx) < 3) return;
      drag.moved = true;
      loupeOpen(drag.el);
    }
    drag.live = Math.max(geo.l0, Math.min(geo.l1, drag.sl + (ev.clientX - drag.sx) / perLinkPx()));
    /* Przyciaganie do osi symetrii. Na telefonie jedno ogniwo to 1–3 px, wiec
       bez tego trafienie w srodek co do ogniwa jest w praktyce niemozliwe.
       Rownamy srodek metalu, a nie otwor montazowy — symetryczna ma byc litera. */
    var dd = dims(drag.el.code);
    var off = (0.5 - dd.ax) * dd.w;
    drag.snap = Math.abs(linkToX(drag.live) + off - midX()) <= SNAP_PX;
    if (drag.snap) drag.live = Math.max(geo.l0, Math.min(geo.l1, xToLinkF(midX() - off)));
    if (midEl) midEl.classList.toggle("vb-on", drag.snap);
    if (drag.raf) return;
    drag.raf = requestAnimationFrame(function () {
      drag.raf = 0;
      if (!drag.el) return;
      var el = drag.el, node = drag.node, d = dims(el.code), y = canvas.clientHeight * CHAIN_Y;
      el.link = Math.round(drag.live);
      var tf = "translate3d(" + (linkToX(drag.live) - d.ax * d.w) + "px," + (y - d.ay * d.h) + "px,0)";
      node.style.transform = tf;
      node.classList.toggle("vb-clash", clashing(el));
      loupeMove(el, tf);
      paint();
    });
  }

  function onUp() {
    if (!drag.el) return;
    var el = drag.el, node = drag.node, moved = drag.moved;
    drag.el = null; drag.node = null; drag.id = -1; drag.snap = false;
    node.classList.remove("vb-dragging");
    if (midEl) midEl.classList.remove("vb-on");
    loupeClose();
    if (!moved) return;                         /* tapniecie bez ruchu = tylko zaznaczenie */
    node.classList.add("vb-settling");
    el.link = Math.round(drag.live); place(node, el);
    lenBase = null;
    state.dirty = true; paint(); queueSave();
    setTimeout(function () { node.classList.remove("vb-settling"); }, 180);
  }

  canvas.addEventListener("pointerdown", onDown);
  canvas.addEventListener("pointermove", onMove);
  canvas.addEventListener("pointerup", onUp);
  canvas.addEventListener("pointercancel", onUp);

  function bindKeys(node, el) {
    node.addEventListener("keydown", function (ev) {
      if (ev.key === "Delete" || ev.key === "Backspace") { ev.preventDefault(); remove(el.uid); return; }
      var d = ev.key === "ArrowLeft" ? -1 : ev.key === "ArrowRight" ? 1 : 0;
      if (!d) return; ev.preventDefault();
      el.link = Math.max(geo.l0, Math.min(geo.l1, el.link + d * (ev.shiftKey ? 5 : 1)));
      lenBase = null;
      place(node, el); state.dirty = true; paint(); queueSave();
    });
    node.addEventListener("focus", function () { setSel(el.uid); });
  }

  /* ---------- interfejs ---------- */
  function paintRail() {
    var rail = $(".vb-rail"), full = state.els.length >= CFG.maxElements;
    if (!rail.children.length) {
      CFG.order.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "vb-chip";
        b.setAttribute("aria-label", "Dodaj " + c);
        b.innerHTML = '<img src="' + CFG.glyphs[c].url + '" alt="' + c + '" loading="lazy">';
        b.addEventListener("click", function () { add(c); });
        rail.appendChild(b);
      });
    }
    Array.prototype.forEach.call(rail.children, function (b) { b.disabled = full; });
  }

  function paintSizes() {
    var s = $(".vb-sizes");
    if (!s.children.length) {
      CFG.sizes.forEach(function (mm) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "vb-opt"; b.textContent = mm + " mm"; b.dataset.mm = mm;
        b.addEventListener("click", function () {
          state.sizeMm = mm; state.dirty = true; paintSizes(); render(); queueSave();
        });
        s.appendChild(b);
      });
    }
    Array.prototype.forEach.call(s.children, function (b) {
      b.setAttribute("aria-pressed", String(+b.dataset.mm === state.sizeMm));
    });
  }

  /* Suwak dlugosci. Pozycje zawieszek trzymamy jako udzial w strefie roboczej
     na czas jednego przeciagniecia — inaczej kazde 1 cm zaokraglaloby uklad
     i przy przejsciu 37 -> 60 cm litery powoli by sie rozjezdzaly. */
  var lenBase = null;
  function paintLen() {
    var v = $(".vb-len-val"), n = $(".vb-len-note"), sl = $(".vb-len");
    if (sl && +sl.value !== state.cm) sl.value = state.cm;
    if (v) v.textContent = state.cm + " cm";
    if (n) n.textContent = state.adjuster
      ? "+ regulator " + CFG.adjExtraCm + " cm → do " + totalCm() + " cm"
      : linkCount() + " ogniw";
    paintFill();
  }
  /* Uchwyt suwaka jest zwykla kulka, a WebKit nie ma odpowiednika
     ::-moz-range-progress — wypelnienie toru rysuje wiec osobny pasek,
     konczacy sie dokladnie w srodku kulki. */
  var THUMB = 22;
  function paintFill() {
    var sl = $(".vb-len"), f = $(".vb-len-fill");
    if (!sl || !f) return;
    var w = sl.clientWidth;
    if (!w) return;
    var span = Math.max(1, CFG.lenMax - CFG.lenMin);
    var pct = Math.max(0, Math.min(1, (state.cm - CFG.lenMin) / span));
    var top = sl.offsetTop + 15;
    f.style.left = sl.offsetLeft + "px";
    f.style.top = top + "px";
    /* szyne rysuje ::before kontenera, wiec musi znac te sama wysokosc */
    if (f.parentNode && f.parentNode.style) f.parentNode.style.setProperty("--vb-track-top", top + "px");
    f.style.width = (THUMB / 2 + pct * (w - THUMB)).toFixed(1) + "px";
  }
  function setLen(cm) {
    if (!lenBase) lenBase = state.els.map(function (e) {
      return (e.link - geo.l0) / Math.max(1, geo.l1 - geo.l0);
    });
    state.cm = clampCm(cm);
    measure();
    state.els.forEach(function (e, i) {
      e.link = Math.round(geo.l0 + lenBase[i] * (geo.l1 - geo.l0));
    });
    state.dirty = true; paintLen(); render(); queueSave();
  }

  /* ---------- wybor lancuszka ----------
     Pozycje zawieszek trzymamy w ogniwach, a ogniwo grubego ma 3,2 mm i
     cienkiego 1,4 mm. Gdyby przy zmianie lancuszka zostawic numer ogniwa,
     litera z 18 cm skoczylaby na 8 cm i caly projekt by sie rozsypal — wiec
     przeliczamy pozycje przez dlugosc ogniwa, czyli zachowujemy centymetry
     od zapiecia. Martwa strefa i minimalne odstepy tez sa liczone w mm,
     wiec projekt miesci sie tak samo na obu lancuszkach. */
  function setChain(ix) {
    var c = CFG.chains[ix];
    if (!c || ix === state.chainIx) return;
    var oldMm = linkMm();
    state.chainIx = ix;
    var r = oldMm / linkMm();
    measure();

    var sorted = state.els.slice().sort(function (a, b) { return a.link - b.link; });
    if (sorted.length) {
      var was = sorted.map(function (e) { return e.link; }), n = was.length;
      /* Przeliczamy ODSTEPY, a nie kazda pozycje z osobna. Gdyby zaokraglac
         kazda pozycje osobno, uklad rowno rozlozony na grubym wychodzil na
         cienkim jako 25, 26, 25, 25 — czyli dokladnie to, czego klient ma
         nie widziec. Przy przeliczaniu odstepow rowne zostaje rowne. */
      var cur = Math.round(was[0] * r);
      sorted[0].link = cur;
      for (var i = 1; i < n; i++) {
        cur += Math.round((was[i] - was[i - 1]) * r);
        sorted[i].link = cur;
      }
      /* caly blok wraca tam, gdzie byl, liczac w centymetrach od zapiecia */
      var shift = Math.round((was[0] + was[n - 1]) / 2 * r - (sorted[0].link + cur) / 2);
      if (sorted[0].link + shift < geo.l0) shift = geo.l0 - sorted[0].link;
      if (cur + shift > geo.l1) shift = geo.l1 - cur;
      sorted.forEach(function (e) {
        e.link = Math.max(geo.l0, Math.min(geo.l1, e.link + shift));
      });
    }

    lenBase = null;
    state.dirty = true;
    paintChains(); render(); paintLen(); queueSave();
  }

  function paintChains() {
    var box = $(".vb-chains"), field = $(".vb-chain-field"), nm = $(".vb-chain-name");
    if (nm) nm.textContent = chain().label;
    if (!box) return;
    if (field) field.hidden = CFG.chains.length < 2;
    if (!box.children.length) {
      CFG.chains.forEach(function (c, i) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "vb-clasp vb-chain-opt"; b.dataset.ix = i;
        b.innerHTML = '<i class="vb-chain-swatch" aria-hidden="true"></i><span></span>';
        b.querySelector(".vb-chain-swatch").style.backgroundImage = "url(" + c.tile + ")";
        b.querySelector("span").textContent = c.label;
        b.addEventListener("click", function () { setChain(i); });
        box.appendChild(b);
      });
    }
    Array.prototype.forEach.call(box.children, function (b) {
      b.setAttribute("aria-pressed", String(+b.dataset.ix === state.chainIx));
    });
  }

  function paintHardware() {
    var cl = $(".vb-clasps"), tg = $(".vb-toggle");
    if (cl && !cl.children.length) {
      CFG.clasps.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "vb-clasp"; b.dataset.cid = c.id;
        b.innerHTML = '<img src="' + c.url + '" alt="' + c.label + '"><span>' + c.label + '</span>';
        b.addEventListener("click", function () {
          state.claspId = c.id; state.dirty = true; paintHardware(); hardware(); queueSave();
        });
        cl.appendChild(b);
      });
    }
    if (cl) Array.prototype.forEach.call(cl.children, function (b) {
      b.setAttribute("aria-pressed", String(b.dataset.cid === state.claspId));
    });
    if (tg) tg.setAttribute("aria-pressed", String(state.adjuster));
  }

  function paint() {
    var n = state.els.length, t = tier(), clash = state.els.some(clashing);
    $(".vb-count").textContent = n + " / " + CFG.maxElements;
    $(".vb-price").textContent = money(t.price);
    /* podpowiedz o progu tylko wtedy, gdy kolejny prog naprawde kosztuje inaczej */
    var nxt = CFG.tiers.filter(function (x) { return x.min > n && x.price !== t.price; })[0];
    $(".vb-tier").textContent = nxt
      ? "od " + nxt.min + " znaków — " + money(nxt.price)
      : "";
    var cta = $(".vb-cta");
    cta.disabled = n === 0 || clash || state.saving;
    cta.textContent = state.saving ? "Zapisuję projekt…"
      : n === 0 ? "Dodaj zawieszki"
      : clash ? "Za ciasno — wydłuż łańcuch albo zmniejsz zawieszki"
      : "Dodaj do koszyka — " + money(t.price);
  }

  /* ---------- zapis projektu ---------- */
  function lenLabel() {
    return state.adjuster
      ? state.cm + " cm (+" + CFG.adjExtraCm + " cm regulator → do " + totalCm() + " cm)"
      : state.cm + " cm";
  }
  function payload() {
    return {
      v: 2,
      chain: { key: chain().key, name: chain().label, widthMm: chain().widthMm,
               cm: state.cm, links: linkCount(), linkMm: +linkMm().toFixed(2), totalCm: totalCm() },
      workZone: { edgeCm: CFG.edgeCm, fromLink: geo.l0, toLink: geo.l1 },
      pendantSizeMm: state.sizeMm,
      clasp: state.claspId,
      adjuster: state.adjuster,
      adjusterCm: state.adjuster ? CFG.adjExtraCm : 0,
      elements: state.els.slice().sort(function (a, b) { return a.link - b.link; })
        .map(function (e) { return { code: e.code, link: e.link }; })
    };
  }

  function rpc(fn, body) {
    return fetch(CFG.dbUrl + "/rest/v1/rpc/" + fn, {
      method: "POST",
      headers: { apikey: CFG.dbKey, Authorization: "Bearer " + CFG.dbKey, "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(fn + " " + r.status);
      return r.json();
    });
  }

  var saveTimer = null;
  function queueSave() {
    if (!CFG.dbUrl) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      if (!state.dirty || !state.els.length) return;
      var p = payload(), t = tier();
      var call = state.designId
        ? rpc("update_design", { p_public_id: state.designId, p_payload: p, p_element_count: state.els.length, p_size_mm: state.sizeMm, p_price_pln: Math.round(t.price / 100) })
        : rpc("create_design", { p_product_type: "chain", p_payload: p, p_element_count: state.els.length, p_size_mm: state.sizeMm, p_price_pln: Math.round(t.price / 100) })
            .then(function (id) { state.designId = id; try { localStorage.setItem("vandal_draft", id); } catch (e) {} });
      call.then(function () { state.dirty = false; }).catch(function () { /* cicho — projekt zyje lokalnie */ });
    }, 2500);
  }

  /* ---------- karta produkcyjna ---------- */
  var imgCache = {};
  function img(src) {
    if (!imgCache[src]) { var i = new Image(); i.crossOrigin = "anonymous"; i.src = src; imgCache[src] = i; }
    return imgCache[src];
  }
  function ready(i) { return i && i.complete && i.naturalWidth; }

  /* Karta pokazuje CALY lancuch: zapiecie -> ogniwo 0 -> ... -> ogniwo N -> regulator.
     Skala pozioma to ogniwa, bo w ogniwach liczy je monter. Dodatkowo tabela
     podaje odstep od poprzedniej zawieszki — po zawieszeniu pierwszej litery
     nie trzeba juz liczyc od poczatku. */
  function buildCard() {
    var W = 1800, H = 1040, cv = document.createElement("canvas");
    cv.width = W; cv.height = H;
    var g = cv.getContext("2d");
    var sorted = state.els.slice().sort(function (a, b) { return a.link - b.link; });
    var lm = linkMm(), N = linkCount();
    var MONO = '"IBM Plex Mono",monospace', DISP = 'Oswald,sans-serif';
    var INK = "#0A0A0B", PAPER = "#F2F3F5", MUTED = "#8A9098", LINE = "#D6D9DD", RED = "#C8102E";

    g.fillStyle = PAPER; g.fillRect(0, 0, W, H);

    /* ---- naglowek ---- */
    g.fillStyle = INK; g.fillRect(0, 0, W, 96);
    g.font = '700 36px ' + DISP; g.fillStyle = "#FFF"; g.fillText("VANDAL", 48, 62);
    var lw = 48 + g.measureText("VANDAL").width + 16;
    g.fillStyle = RED; g.fillText("//", lw, 62);
    g.font = '600 26px ' + DISP; g.fillStyle = "#FFF";
    g.fillText("KARTA PRODUKCYJNA", lw + g.measureText("//").width + 20, 60);
    g.font = '500 15px ' + MONO; g.fillStyle = "#9AA0A7"; g.textAlign = "right";
    g.fillText(state.designId || "(szkic)", W - 48, 42);
    g.fillText(new Date().toLocaleDateString("pl-PL"), W - 48, 66);
    g.textAlign = "left";

    /* ---- scena: caly lancuch ---- */
    var sx = 48, sy = 132, sw = W - 96, sh = 320;
    g.fillStyle = "#101114"; g.fillRect(sx, sy, sw, sh);

    var endL = 112, endR = state.adjuster ? 176 : 76;
    var cx0 = sx + endL, cx1 = sx + sw - endR;
    var perL = (cx1 - cx0) / Math.max(1, N), pxmm = perL / lm;
    var cy = sy + sh * 0.42;
    var tileW = perL * CFG.linksPerTile, tileH = tileW * CFG.tileAspect;

    g.save(); g.beginPath(); g.rect(sx, sy, sw, sh); g.clip();

    var ci = img(chain().tile);
    if (ready(ci)) {
      for (var x = cx0; x < cx1; x += tileW) {
        var w = Math.min(tileW, cx1 - x);
        g.drawImage(ci, 0, 0, Math.max(1, ci.naturalWidth * (w / tileW)), ci.naturalHeight,
                    x, cy - tileH / 2, w, tileH);
      }
    }

    var clasp = CFG.clasps.filter(function (c) { return c.id === state.claspId; })[0];
    if (clasp && ready(img(clasp.url))) {
      var hw = 86, hh = hw / clasp.ratio;
      g.drawImage(img(clasp.url), cx0 - hw + 8, cy - hh / 2, hw, hh);
    }
    if (state.adjuster && CFG.adjuster.url && ready(img(CFG.adjuster.url))) {
      var aw = 158, ah = aw / CFG.adjuster.ratio;
      g.drawImage(img(CFG.adjuster.url), cx1 - 8, cy - ah / 2, aw, ah);
    }

    sorted.forEach(function (e) {
      var G = CFG.glyphs[e.code], im = img(G.url);
      if (!ready(im)) return;
      var h = state.sizeMm * pxmm, ww = h * G.w / G.h;
      g.drawImage(im, cx0 + e.link * perL - G.ax * ww, cy - G.ay * h, ww, h);
    });
    g.restore();

    /* podpisy koncow */
    g.font = '500 11px ' + MONO; g.fillStyle = "#6E757D";
    g.fillText(chain().label.toUpperCase() + " · CAŁY ŁAŃCUCH OD ZAPIĘCIA DO KOŃCA · SKALA W OGNIWACH (1 ogniwo = "
               + lm.toFixed(1) + " mm)", sx + 18, sy + 26);
    g.textAlign = "center";
    g.fillText("ZAPIĘCIE", cx0 - 46, cy + 46);
    if (state.adjuster) g.fillText("REGULATOR +" + CFG.adjExtraCm + " cm", cx1 + 78, cy + 46);
    else g.fillText("KONIEC", cx1 + 34, cy + 46);

    /* ---- skala w ogniwach ---- */
    var ry = sy + sh - 48;
    g.strokeStyle = "#3A3F45"; g.lineWidth = 1;
    g.beginPath(); g.moveTo(cx0, ry); g.lineTo(cx1, ry); g.stroke();
    var big = N > 150 ? 25 : N > 90 ? 20 : 10, small = big / 5;
    g.font = '500 12px ' + MONO;
    for (var l = 0; l <= N; l += small) {
      var px = cx0 + l * perL, isBig = (l % big === 0);
      g.strokeStyle = isBig ? "#6E757D" : "#3A3F45";
      g.beginPath(); g.moveTo(px, ry); g.lineTo(px, ry + (isBig ? 10 : 5)); g.stroke();
      if (isBig) { g.fillStyle = "#6E757D"; g.fillText(String(l), px, ry + 28); }
    }
    /* numer ostatniego ogniwa tylko wtedy, gdy nie wejdzie na poprzedni opis */
    if (N % big >= big * 0.45) { g.fillStyle = "#6E757D"; g.fillText(String(N), cx1, ry + 28); }
    g.strokeStyle = RED; g.lineWidth = 2;
    sorted.forEach(function (e) {
      var px = cx0 + e.link * perL;
      g.beginPath(); g.moveTo(px, ry - 13); g.lineTo(px, ry); g.stroke();
    });
    g.lineWidth = 1; g.textAlign = "left";

    /* ---- pasek parametrow ---- */
    /* ta sama matematyka co w podgladzie — stale cm zapasu z obu koncow */
    var edge = Math.round(CFG.edgeCm * 10 / lm);
    edge = Math.max(0, Math.min(edge, Math.floor((N - 8) / 2)));

    var by = sy + sh + 52, col = (W - 96) / 5;
    [["UKŁAD (OD LEWEJ)", sorted.map(function (e) { return e.code; }).join(" · ")],
     ["ROZMIAR ZAWIESZKI", state.sizeMm + " mm (wysokość)"],
     ["ŁAŃCUCH · " + chain().label.toUpperCase(), state.cm + " cm · " + N + " ogniw"],
     ["STREFA ROBOCZA (" + CFG.edgeCm + " cm od końców)", "ogniwa " + edge + "–" + (N - edge)],
     ["ZAPIĘCIE / REGULATOR",
      ((clasp || {}).label || "—") + " / " + (state.adjuster ? "TAK +" + CFG.adjExtraCm + " cm" : "NIE")]
    ].forEach(function (cell, i) {
      var x = 48 + i * col;
      g.fillStyle = MUTED; g.font = '500 11px ' + MONO; g.fillText(cell[0], x, by);
      g.fillStyle = INK; g.font = '600 22px ' + DISP; g.fillText(cell[1], x, by + 32);
      if (i) { g.strokeStyle = LINE; g.beginPath(); g.moveTo(x - 24, by - 16); g.lineTo(x - 24, by + 42); g.stroke(); }
    });

    /* ---- tabela pozycji ---- */
    var ty = by + 98, C = [48, 124, 250, 560, 900], TW = 1160;
    g.fillStyle = MUTED; g.font = '500 11px ' + MONO;
    ["LP", "ZNAK", "OGNIWO OD ZAPIĘCIA", "OGNIW OD POPRZEDNIEJ", "ODSTĘP (mm)"].forEach(function (h, i) {
      g.fillText(h, C[i], ty);
    });
    g.strokeStyle = LINE; g.beginPath(); g.moveTo(48, ty + 12); g.lineTo(48 + TW, ty + 12); g.stroke();

    var rowH = 32, y0 = ty + 42;
    sorted.forEach(function (e, i) {
      var prev = i ? sorted[i - 1].link : 0, d = e.link - prev, y = y0 + i * rowH;
      if (i % 2 === 0) { g.fillStyle = "#E7E9ED"; g.fillRect(40, y - 22, TW + 16, rowH); }
      g.fillStyle = INK; g.font = '500 16px ' + MONO; g.fillText(String(i + 1), C[0], y);
      g.font = '700 22px ' + DISP; g.fillText(e.code, C[1], y + 1);
      g.font = '600 18px ' + MONO; g.fillText(String(e.link), C[2], y);
      g.font = '600 18px ' + MONO;
      g.fillStyle = i ? RED : INK;
      g.fillText(i === 0 ? d + "  (od zapięcia)" : "+ " + d, C[3], y);
      g.fillStyle = INK; g.font = '500 16px ' + MONO;
      g.fillText(Math.round(d * lm) + " mm", C[4], y);
    });

    var lastLink = sorted.length ? sorted[sorted.length - 1].link : 0;
    var yEnd = y0 + sorted.length * rowH;
    g.fillStyle = MUTED; g.font = '500 15px ' + MONO;
    g.fillText("—", C[0], yEnd);
    g.font = '500 12px ' + MONO; g.fillText("koniec łańcucha", C[1], yEnd);
    g.font = '500 15px ' + MONO; g.fillText(String(N), C[2], yEnd);
    g.fillText("+ " + (N - lastLink), C[3], yEnd);
    g.fillText(Math.round((N - lastLink) * lm) + " mm", C[4], yEnd);

    /* ---- instrukcja liczenia ---- */
    var nx = 1250, ny = ty - 22, nw = W - 48 - nx, nh = 214;
    g.fillStyle = "#E7E9ED"; g.fillRect(nx, ny, nw, nh);
    g.fillStyle = RED; g.fillRect(nx, ny, 4, nh);
    g.fillStyle = INK; g.font = '600 15px ' + DISP;
    g.fillText("JAK LICZYĆ", nx + 22, ny + 32);
    g.fillStyle = "#3C4147"; g.font = '500 13px ' + MONO;
    [
      "1. Pierwszą zawieszkę zawieś na ogniwie",
      "   nr " + (sorted.length ? sorted[0].link : 0) + " licząc od zapięcia.",
      "2. Każdą następną odliczaj od poprzedniej",
      "   zawieszki — kolumna „ogniw od poprzedniej”.",
      "3. Po ostatniej zostaje " + (N - lastLink) + " ogniw do końca —",
      "   to kontrola poprawności układu.",
      chain().label + ": " + N + " ogniw = " + state.cm + " cm."
    ].forEach(function (t, i) {
      g.fillText(t, nx + 22, ny + 62 + i * 22);
    });

    /* ---- stopka ---- */
    g.fillStyle = LINE; g.fillRect(48, H - 66, W - 96, 1);
    g.fillStyle = MUTED; g.font = '500 11px ' + MONO;
    g.fillText("Projekt zatwierdzony przez klienta w konfiguratorze. Wykonać dokładnie wg układu powyżej.", 48, H - 40);
    return cv;
  }

  /* Karta nie moze wyjsc z brakujaca litera — Mateusz zrobilby wtedy zly wisior.
     Zanim ja narysujemy, czekamy az wszystkie potrzebne grafiki sie wczytaja. */
  function waitForCardImages(ms) {
    var urls = state.els.map(function (e) { return CFG.glyphs[e.code].url; });
    urls.push(chain().tile);
    var cl = CFG.clasps.filter(function (c) { return c.id === state.claspId; })[0];
    if (cl) urls.push(cl.url);
    if (state.adjuster && CFG.adjuster && CFG.adjuster.url) urls.push(CFG.adjuster.url);
    var uniq = urls.filter(function (u, i) { return urls.indexOf(u) === i; });

    return Promise.all(uniq.map(function (u) {
      return new Promise(function (res, rej) {
        var im = img(u);
        if (ready(im)) return res(u);
        /* obrazek, ktory juz raz padl, ma complete=true i naturalWidth=0 —
           zadne zdarzenie sie nie powtorzy, wiec ratuje nas limit czasu */
        var t = setTimeout(function () { rej(new Error("grafika niewczytana (limit czasu)")); }, ms || 12000);
        im.addEventListener("load", function () { clearTimeout(t); res(u); }, { once: true });
        im.addEventListener("error", function () { clearTimeout(t); rej(new Error("grafika niewczytana (blad)")); }, { once: true });
      });
    }));
  }

  function uploadCard(designId) {
    return new Promise(function (resolve) {
      buildCard().toBlob(function (blob) {
        if (!blob || !CFG.dbUrl) return resolve(null);
        var path = "karty/" + designId + ".png";
        fetch(CFG.dbUrl + "/storage/v1/object/designs/" + path, {
          method: "POST",
          headers: { apikey: CFG.dbKey, Authorization: "Bearer " + CFG.dbKey, "Content-Type": "image/png" },
          body: blob
        }).then(function (r) {
          resolve(r.ok ? CFG.dbUrl + "/storage/v1/object/public/designs/" + path : null);
        }).catch(function () { resolve(null); });
      }, "image/png");
    });
  }

  /* ---------- koszyk ---------- */
  function addToCart() {
    var t = tier(), sorted = state.els.slice().sort(function (a, b) { return a.link - b.link; });
    state.saving = true; paint();

    var ensure = state.designId
      ? Promise.resolve(state.designId)
      : rpc("create_design", {
          p_product_type: "chain", p_payload: payload(),
          p_element_count: state.els.length, p_size_mm: state.sizeMm,
          p_price_pln: Math.round(t.price / 100)
        }).then(function (id) { state.designId = id; return id; });

    ensure
      .then(function (id) {
        return rpc("update_design", {
          p_public_id: id, p_payload: payload(),
          p_element_count: state.els.length, p_size_mm: state.sizeMm,
          p_price_pln: Math.round(t.price / 100)
        }).then(function () { return waitForCardImages(12000); })
          .then(function () { return uploadCard(id); })
          .then(function (cardUrl) {
            return rpc("lock_design", { p_public_id: id, p_card_url: cardUrl, p_preview_url: cardUrl })
              .then(function () { return { id: id, card: cardUrl }; });
          });
      })
      .then(function (r) {
        var props = {
          "_design_id": r.id,
          "Projekt": sorted.map(function (e) { return e.code; }).join(" · "),
          "Rozmiar zawieszki": state.sizeMm + " mm",
          "Łańcuch": chain().label,
          "Długość łańcucha": lenLabel(),
          "Pozycje (ogniwa)": sorted.map(function (e, i) {
            return e.code + " " + e.link + (i ? " (+" + (e.link - sorted[i - 1].link) + ")" : "");
          }).join(" · ")
        };
        var cl = CFG.clasps.filter(function (c) { return c.id === state.claspId; })[0];
        if (cl) props["Zapięcie"] = cl.label;
        props["Regulator długości"] = state.adjuster ? "tak (+" + CFG.adjExtraCm + " cm)" : "nie";
        if (r.card) props["Karta produkcyjna"] = r.card;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: t.variant, quantity: 1, properties: props }] })
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "Nie udało się dodać do koszyka"); });
        try { localStorage.removeItem("vandal_draft"); } catch (e) {}
        window.location.href = "/cart";
      })
      .catch(function (e) {
        state.saving = false; paint();
        var box = $(".vb-error");
        box.textContent = /grafika niewczytana/.test(e.message)
          ? "Nie udało się wczytać wszystkich grafik projektu, więc nie wysyłamy niekompletnego zamówienia. Odśwież stronę i spróbuj ponownie."
          : "Nie udało się dodać do koszyka. Odśwież stronę i spróbuj ponownie.";
        box.hidden = false;
        if (window.console) console.error("[vandal]", e);
      });
  }

  /* ---------- start ---------- */
  Object.keys(CFG.glyphs).forEach(function (c) { img(CFG.glyphs[c].url); });
  CFG.chains.forEach(function (c) { img(c.tile); });
  CFG.clasps.forEach(function (c) { img(c.url); });
  if (CFG.adjuster && CFG.adjuster.url) img(CFG.adjuster.url);

  paintRail(); paintSizes(); paintChains(); paintHardware(); render(); paintLen();

  var slider = $(".vb-len");
  if (slider) {
    slider.addEventListener("input", function () { setLen(+slider.value); });
    slider.addEventListener("change", function () { lenBase = null; });
  }

  var tgl = $(".vb-toggle");
  if (tgl) tgl.addEventListener("click", function () {
    state.adjuster = !state.adjuster;
    state.dirty = true; paintHardware(); render(); paintLen(); queueSave();
  });

  if (selDel) selDel.addEventListener("click", function () { if (state.sel) remove(state.sel); });
  if (centerBtn) centerBtn.addEventListener("click", centerAll);
  if (evenBtn) evenBtn.addEventListener("click", evenGaps);
  if (resetBtn) resetBtn.addEventListener("click", resetAll);
  if (undoBtn) undoBtn.addEventListener("click", undoKill);

  $(".vb-cta").addEventListener("click", addToCart);

  var rz;
  window.addEventListener("resize", function () {
    clearTimeout(rz);
    rz = setTimeout(function () {
      var keep = state.els.map(function (e) { return e.link; });
      measure(); drawChain(); hardware();
      state.els.forEach(function (e, i) { e.link = keep[i]; place(nodes[e.uid], e); });
      paint(); paintFill();
    }, 120);
  });
})();
